// import { FaFileExcel, FaFileImport } from "react-icons/fa"; // Import the desired icons
// import { GrCompare } from "react-icons/gr";
// import { FaRegEdit } from "react-icons/fa";
// import Home from "./components/pages/Home/Home";
// import EditProduct from "./components/pages/EditProduct";
// import ComparePrices from "./components/pages/ComparePrices/ComparePrices";
// import ImportLAD from "./components/pages/Ecommerce/importLAD";

// interface Routes {
//   [key: string]: Route;
// }
// interface Route {
//   path?: string;
//   icon?: JSX.Element;
//   component?: React.FC;
//   subRoutes?: Routes;
// }
// let rolePriceComparator = localStorage.getItem("RightPriceComparator") || "";

// export const routesComponent: Routes = {
//   "Ajout d'articles": {
//     path: "/home",
//     icon: <FaFileExcel />,
//     component: <Home />,
//   },
//   "Modification d'article ": {
//     path: "/editProduct",
//     icon: <FaRegEdit />,
//     component: <EditProduct />,
//   },

//   Plateforme: {
//     subRoutes: {
//       "Comparateur de prix": {
//         path: "/comparingPrices",
//         icon: <GrCompare />,
//         component: ComparePrices,
//       },
//       "Ajout d'articles": {
//         path: "/home",
//         icon: <FaFileExcel />,
//         component: Home,
//       },
//       "Modification d'article ": {
//         path: "/editProduct",
//         icon: <FaRegEdit />,
//         component: EditProduct,
//       },
//     },
//   },
//   "E-commerce": {
//     subRoutes: {
//       "Import LAD": {
//         path: "/importLAD",
//         icon: <FaFileImport />,
//         component: ImportLAD,
//       },
//     },
//   },
// };
import { FaFileExcel, FaFileImport, FaHistory, FaHome } from "react-icons/fa";
import { GrCompare } from "react-icons/gr";
import { FaRegEdit } from "react-icons/fa";
import Home from "./components/pages/Home/Home";
import EditProduct from "./components/pages/EditProduct";
import ComparePrices from "./components/pages/ComparePrices/ComparePrices";
import ImportLAD from "./components/pages/Ecommerce/importLAD";
import Accueil from "./components/pages/Accueil/Accueil";
import ProdcutInjectorSupport from "./components/pages/ProductInjectorSupport/ProductInjectorSupport";
import ComparePricesPerAdh from "./components/pages/ComparePricesPerAdh/ComparePricesPerAdh";
import { GrMultiple } from "react-icons/gr";
import StatsMarketing from "./components/pages/StatsMarketing/StatsMarketing"; // Corrected path for StatsMarketing component
import { ImStatsDots } from "react-icons/im";
import Historique from "./components/pages/Ecommerce/historique";
import ComparePricesRefonte from "./components/pages/ComparePrices/ComparePricesRefonte";

interface Routes {
  [key: string]: Route;
}
interface Route {
  path?: string;
  icon?: JSX.Element;
  subRouteDescription?: string;
  component?: React.FC;
  subRoutes?: Routes;
}

// Retrieve user rights from localStorage

const rolePriceComparator = localStorage.getItem("rights") || "";
//("PlateformComparePricesEcommerceImportLADAddArticles<EditProduct");
console.log("test", localStorage.getItem("rights"));
// Function to generate routes based on user rights
export const generateRoutes = (role: string): Routes => {
  const routes: Routes = {};
  routes["Accueil"] = {
    path: "/Accueil",
    icon: <FaHome />,
    component: Accueil,
  };
  routes["Refonte"] = {
    path: "/Refonte",
    icon: <FaHome />,
    component: ComparePricesRefonte,
  };
  const hasPlateformAccess = role.includes("Plateform");
  const hasEcommerceAccess = role.includes("Ecommerce");
  const hasComparePricesAccess = role.includes("ComparePrices");
  const hasAddArticlesAccess = role.includes("AddArticles");
  const hasEditProductAccess = role.includes("EditProduct");
  const hasImportLADAccess = role.includes("ImportLAD");
  const hasSupportAccess = role.includes("Support");
  const hasProductInjectorSupportAccess = role.includes("ProductInjector");
  const hasComparePerAdhAcccess = role.includes("ComparePricesPerAdh");
  const hasStatsMarketingAccess = role.includes("StatsMarketing"); // Check for StatsMarketing role

  if (hasPlateformAccess) {
    const plateformeSubRoutes: Routes = {};

    if (hasComparePricesAccess) {
      plateformeSubRoutes["Comparateur de prix"] = {
        path: "/Plateform/ComparePrices",
        icon: <GrCompare />,
        subRouteDescription:
          "Comparer les prix d'un adhérent pour connaitre quel produit est plus rentable côté plateforme ou client",
        component: ComparePrices,
      };
    }

    if (hasAddArticlesAccess) {
      plateformeSubRoutes["Ajout d'articles"] = {
        path: "/Plateform/AddArticles",
        icon: <FaFileExcel />,
        subRouteDescription:
          "Permet d'ajouter plusieurs articles grâce à un fichier excel.",
        component: Home,
      };
    }

    if (hasEditProductAccess) {
      plateformeSubRoutes["Modification d'article"] = {
        path: "/Plateform/EditProduct",
        icon: <FaRegEdit />,
        subRouteDescription: "Permet de modifier un article d'une société",
        component: EditProduct,
      };
    }
    if (hasComparePerAdhAcccess) {
      plateformeSubRoutes["Comparaison par ahérent"] = {
        path: "/Plateform/ComparePricesPerAdh",
        icon: <GrMultiple />,
        subRouteDescription:
          "Permet de Comparer le prix des articles entre tous les adh",
        component: ComparePricesPerAdh,
      };
    }

    if (Object.keys(plateformeSubRoutes).length > 0) {
      routes["Plateforme"] = {
        subRoutes: plateformeSubRoutes,
      };
    }
  }

  if (hasEcommerceAccess) {
    const ecommerceSubRoutes: Routes = {};

    if (hasImportLADAccess) {
      ecommerceSubRoutes["Import LAD"] = {
        path: "/Ecommerce/ImportLAD",
        icon: <FaFileImport />,
        subRouteDescription:
          "Importation en base de donnée grâce à un fichier Excel",
        component: ImportLAD,
      };
      ecommerceSubRoutes["Historique LAD"] = {
        path: "/Ecommerce/HistoricLAD",
        icon: <FaHistory />,
        subRouteDescription: "Historique LAD - Exclusivité Web",
        component: Historique,
      };
    }

    if (Object.keys(ecommerceSubRoutes).length > 0) {
      routes["E-commerce"] = {
        subRoutes: ecommerceSubRoutes,
      };
    }
  }
  if (hasSupportAccess) {
    const supportSubRoutes: Routes = {};

    if (hasProductInjectorSupportAccess) {
      supportSubRoutes["Ajout d'articles "] = {
        path: "/Support/ProductInjector",
        icon: <FaFileImport />,
        subRouteDescription:
          "Importation en base de donnée grâce à un fichier Excel",
        component: ProdcutInjectorSupport,
      };
    }

    if (Object.keys(supportSubRoutes).length > 0) {
      routes["Support"] = {
        subRoutes: supportSubRoutes,
      };
    }
  }

  if (hasStatsMarketingAccess) {
    const marketingSubRoutes: Routes = {};

    marketingSubRoutes["Statistiques Marketing"] = {
      path: "/Marketing/StatsMarketing",
      icon: <ImStatsDots />,
      subRouteDescription: "Visualiser les statistiques marketing",
      component: StatsMarketing,
    };

    if (Object.keys(marketingSubRoutes).length > 0) {
      routes["Marketing"] = {
        subRoutes: marketingSubRoutes,
      };
    }
  }

  return routes;
};

// Generate routes based on the retrieved rights
export const routesComponent: Routes = generateRoutes(rolePriceComparator);
